import { Component, ViewChild } from '@angular/core';
import { ProjectEditService } from './project.form.service';
import { AppService } from '../../app.service';
import { FormControl, FormGroup, FormArray } from '@angular/forms';
import { ProjectViewService } from '../ProjectViewComponent/project.view.service';
import { Formvalidator } from './project.form.formvalidator'
import { ActivatedRoute } from '@angular/router'; 
import { Location } from '@angular/common';
import { DateAdapter, MatDatepicker } from '@angular/material';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { PersonFormService } from '../../PersonComponent/PersonFormComponent/person.form.service';
import { EmployerViewService } from '../../EmployerComponent/EmployerViewComponent/employer.view.service';

import { ValidationModalComponent } from '../../shared/views/ValidationModalComponent/validation.modal.component';

@Component({
    selector: 'project-comp',
    providers: [ProjectEditService, AppService, Formvalidator, ProjectViewService, ConfirmService, MatDatepicker, PersonFormService, EmployerViewService], 
    templateUrl: './project.form.component.html',  
    styleUrls: ['../project.component.css'] 
})

export class ProjectFormComponent {
    
    @ViewChild('validationModal') validationModal: ValidationModalComponent;

    private project: any;
    private activeComponent: boolean;
    statusOptions = ["Under upphandling", "SUA-godkänd"];
    selectedCompany: any;
    companySelected: Boolean = false;
    suaGovForm: FormGroup;
    suaForm: FormGroup;
    showLoader: Boolean = false;
    type: String;
    id: String;
    employerId: String;
    edit: Boolean = false;
    controlReasons: FormGroup;
    projectLead: FormGroup;
    reasonArray: any = [];
    ready: Boolean = false;
    contractor: any;
    companies: any = [];

    constructor(
        private service: ProjectEditService,
        private viewService: ProjectViewService,
        private formValidator: Formvalidator,
        private activatedRoute: ActivatedRoute,
        private dateAdapter: DateAdapter<Date>,
        private confirmService: ConfirmService,
        private location: Location,
        private personFormService: PersonFormService,
        private employerViewService: EmployerViewService,
        private appService: AppService) {
            this.activeComponent = appService.isComponentActive('project');
            this.id = this.activatedRoute.snapshot.paramMap.get('id');
            this.type = this.activatedRoute.snapshot.paramMap.get('type');
            this.setDefault();      
            if(this.id != null && this.type === 'edit') {
                this.editProject(this.id);
            } else if (this.id === null && this.type === 'new') {
                this.setDefault();
                this.getEmployers();
            }
        }

    /**
     * Initiates values
     */
    setDefault() {
        this.dateAdapter.setLocale('se');
        this.suaGovForm = new FormGroup({
            id: new FormControl(),

            govFullName: new FormControl(),
            govPhone: new FormControl(),
            govPostAddress: new FormControl(),
            govPostNumber: new FormControl(),
            govPostCity: new FormControl(),
            suaProjectStatus: new FormControl(),
            suaCompanyStatus: new FormControl(),

            compOrgId: new FormControl(),
            compName: new FormControl(),
            compIndustry: new FormControl(),
            compPostAddress: new FormControl(),
            compPostNumber: new FormControl(),
            compPostCity: new FormControl(),
            compPhoneNumber: new FormControl(),

            compProjectName: new FormControl(),
            compSupplier: new FormControl(),
            compSecChief: new FormControl(),
            compSecPhoneNumber: new FormControl(),
            compSecondSecChief: new FormControl(),
            compSecondSecPhoneNumber: new FormControl(),

            compSecContractLevel: new FormControl(),
            compSecContractDate: new FormControl(),
            regControl:new FormControl(),
            contractVoided: new FormControl(),
            contractVoidDate: new FormControl(),

            employerId: new FormControl()
        });
        /*
        this.suaForm = new FormGroup({
            id: new FormControl(),
            suaName: new FormControl(),
            suaStartDate: new FormControl(new Date()),
            suaEndDate: new FormControl(),
            suaSupplier: new FormControl(),
            suaStatus: new FormControl(),
            
            /**Control reason 
            reasonInput: new FormControl(),
            selectedReason: new FormControl(),
            'controlReason': new FormArray([]),

            contractor: new FormControl()
        });
        this.projectLead = new FormGroup({
            projectLeadName: new FormControl(),
            projectLeadPhone: new FormControl(),
            assistantProjectLeadName: new FormControl(),
            assistantProjectLeadPhone: new FormControl()
        });*/
        this.ready = true;
    }

    /**
     * Opens view for editing a project
     * @param id Unique identifier for project to be edited
     */
    editProject(id) {
        this.viewService.getProjectById(id)      
        .subscribe(
            data => this.setProject(data),
            error =>  this.showError(error.error)   
        );
    }
    
    /**
     * Adds a department to the department list
     * @param inputName name of the department
    
    addReasonToList(reasonInput) {
        if(!this.formValidator.validateCause(reasonInput)) {
            if(reasonInput.id === undefined) {
            reasonInput = {
                reason: reasonInput
                }
            }

            if(this.validateInput(reasonInput.reason, (<FormArray>this.suaForm.get('controlReason')))) {
                (<FormArray>this.suaForm.get('controlReason')).push(new FormGroup({
                    id: new FormControl(reasonInput.id),
                    reason: new FormControl(reasonInput.reason)
                }));
                this.reasonArray = (<FormArray>this.suaForm.get('controlReason')).value;
                this.suaForm.patchValue({reasonInput: null});
            }
        }
        return false;
    } */

    setCompany(companyId) {
        for(let i=0; i < this.companies.length; i++) {
            if(this.companies[i].id === companyId){
                this.selectedCompany = this.companies[i];
            }
        }
        this.patchEmployerForm(this.selectedCompany);
    }

    validateInput(input, formArray) {
        let validInput = true;
        for(let i=0; i < formArray.length; i++) {
            if (input.toUpperCase() == formArray.value[i].reason.toUpperCase()) {
                validInput = false;
            }
        }
        return validInput;
    }

    deleteReasonFromList(reasonIndex) {
        let removeIndex:number = 0;
        if((<FormArray>this.suaForm.get('controlReason')).length == 1) {
            removeIndex = 0;
        } else {
            removeIndex = ++reasonIndex;
        }
        (<FormArray>this.suaForm.get('controlReason')).removeAt(removeIndex);
    }

    /**
     * Displays a project
     * @param project Project to be displayed
     */
    patchEmployerForm(employer) {
        this.suaGovForm.patchValue({
            compOrgId: employer.organisationId,
            compName: employer.name,
            compPostAddress: employer.addresses[0].address_1,
            compPostNumber: employer.addresses[0].postCode,
            compPostCity: employer.addresses[0].city,
            compPhoneNumber: employer.contactPhone
        });
        this.disableEmployerInputFields();
        
        /*for(let i = 0; i < project.controlReason.length; i++) {
            this.addReasonToList(project.controlReason[i]);
        }
        this.projectLead.patchValue({
            projectLeadName: project.projectLeadName,
            projectLeadPhone: project.projectLeadPhone,
            assistantProjectLeadName: project.assistantProjectLeadName,
            assistantProjectLeadPhone: project.assistantProjectLeadPhone,
        })*/
        
        if(employer.suaStatus == "suaEmployer") {
            this.suaGovForm.patchValue({
                suaCompanyStatus: this.statusOptions[1],
            });
            this.suaGovForm.get('suaCompanyStatus').disable();
        } else if(employer.suaStatus == "inBidding") {
            this.suaGovForm.patchValue({
                suaCompanyStatus: this.statusOptions[0],
            });
            this.suaGovForm.get('suaCompanyStatus').disable();
        }
        this.suaGovForm.patchValue({
            suaProjectStatus: "Ej skickad"
        });
        this.companySelected = true;
    }

    /**
     * Disables employers input fields that are automatically
     * filled by the application to prevent user data
     */
    disableEmployerInputFields() {
        this.suaGovForm.get('compOrgId').disable();
        this.suaGovForm.get('compName').disable();
        this.suaGovForm.get('compPostAddress').disable();
        this.suaGovForm.get('compPostNumber').disable();
        this.suaGovForm.get('compPostCity').disable();
        this.suaGovForm.get('compPhoneNumber').disable();
    }

    /**
     * Sets form data for a project
     * @param project Project entity from backend
     */
    setProject(project) {
        this.suaGovForm.patchValue({
            id: project.id,
            employerId: project.employer.id,
            compOrgId: project.employer.organisationId,
            compName: project.employer.name,
            compPostAddress: project.employer.addresses[0].address_1,
            compPostNumber: project.employer.addresses[0].postCode,
            compPostCity: project.employer.addresses[0].city,
            compPhoneNumber: project.employer.contactPhone,
            compIndustry: project.compIndustry,
            govFullName: project.govFullName,
            govPhone: project.govPhone,
            govPostAddress: project.govPostAddress,
            govPostNumber: project.govPostNumber,
            govPostCity: project.govPostCity,
            suaCompanyStatus: project.suaCompanyStatus,
            suaProjectStatus: project.suaProjectStatus,

            compProjectName: project.compProjectName,
            compSupplier: project.compSupplier,
            compSecChief: project.compSecChief,
            compSecPhoneNumber: project.compSecPhoneNumber,
            compSecondSecChief: project.compSecondSecChief,
            compSecondSecPhoneNumber: project.compSecondSecPhoneNumber,

            compSecContractLevel: project.compSecContractLevel,
            compSecContractDate: new Date(project.compSecContractDate),
            regControl: project.regControl,
            contractVoided: project.contractVoided,
        });
        if(project.contractVoidDate != null) {
            this.suaGovForm.patchValue({
                contractVoidDate: new Date(project.contractVoidDate)
            })
        }
        this.companySelected = true;
        this.selectedCompany = project.employer;
        this.disableEmployerInputFields();
        this.suaGovForm.get('suaCompanyStatus').disable();
        this.edit = true;
    }

    /**
     * Fetches all employers from the backend
     */
    getEmployers() {
        this.personFormService.getAllEmployers()
            .subscribe(
                data => this.setEmployers(data),
                error => this.showError(error.error)       
      )
    }

    /**
     * Sets the employer data
     * @param data 
     */
    setEmployers(data) {
        for(let i=0; i < data.length; i++) {
            if(data[i].suaStatus === 'suaEmployer' || data[i].suaStatus === 'inBidding') {
                this.companies.push(data[i]);
            }
        }
       /* this.suaForm.patchValue({
            contractor: this.company[0].id
        })*/
    }

    /**
     * Saves a project to the database
     * @param suaForm 
     * @param projectLead
     */
    saveProject(suaForm) {
        if(this.formValidator.validateProjectForm(suaForm, this.validationModal.getModalArray())) {
            suaForm.suaCompanyStatus =  this.suaGovForm.getRawValue().suaCompanyStatus;
            this.service.saveProject(suaForm).subscribe(
                data => this.setRoute('project/view/' + data.id),
                error => this.showError(error.error),
                () => this.showLoader = false
            );
        } else {
            this.validationModal.pop();
        }
    }

    /**
     * Update existing project
     * @param suaForm project form data
     */
    updateProject(suaForm) {
        if(this.formValidator.validateProjectForm(suaForm, this.validationModal.getModalArray())) {
            suaForm.suaCompanyStatus = this.suaGovForm.getRawValue().suaCompanyStatus;
            this.service.updateProject(suaForm)
                .subscribe(
                data => this.setRoute('project/view/' + data.id),
                error => this.showError(error.error)
            );
        } else {
            this.validationModal.pop();
        }
    }

    /**
     * Go back to the previous view from where we came
     */
    back() {
        this.confirmService.confirm('Inga ändringar kommer sparas om du avbryter. Vill du fortsätta?')
            .then(result => {
                if(result) {
                    this.location.back();
                }
            });
    }

    /**
     * Prints error in console
     * @param error Error caused
     */
    showError(error) {
        this.validationModal.setModalData(["Felaktig data", "Projektet kunde inte sparas. Kontrollera så att inga specialtecken förekommer i fälten. \
                                            Följande tecken tillåts: A-Ö1-9 ,"]);
        this.validationModal.pop();
    }

    /**
     * Sets the new route
     * @param destination Route destination
     */
    setRoute(destination) {      
        this.appService.setRoute(destination);
    }
}
